import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';

@Component({
  selector: 'app-nova-launcher',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './nova-launcher.component.html',
  styleUrl: './nova-launcher.component.scss',
})
export class NovaLauncherComponent {
  constructor(private router: Router) {}

  get hidden(): boolean {
    return this.router.url.startsWith('/nova');
  }

  openNova(): void {
    this.router.navigate(['/nova']);
  }
}
